import { render, staticRenderFns } from "./CompetitionPicksList.vue?vue&type=template&id=11e6c42c&"
import script from "./CompetitionPicksList.vue?vue&type=script&lang=ts&"
export * from "./CompetitionPicksList.vue?vue&type=script&lang=ts&"
import style0 from "./CompetitionPicksList.vue?vue&type=style&index=0&id=11e6c42c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports